import { render, staticRenderFns } from "./MergeContactSummary.vue?vue&type=template&id=08b8e066&scoped=true&"
import script from "./MergeContactSummary.vue?vue&type=script&lang=js&"
export * from "./MergeContactSummary.vue?vue&type=script&lang=js&"
import style0 from "./MergeContactSummary.vue?vue&type=style&index=0&id=08b8e066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8e066",
  null
  
)

export default component.exports